import { FaCalendarAlt, FaGraduationCap, FaLayerGroup } from "react-icons/fa";

export const PROVIDER_SETTINGS_TABS = [
  {
    id: "levels",
    label: "Course Levels",
    subtitle: "Manage course level definitions and categories",
    icon: FaGraduationCap,
  },
  {
    id: "intakes",
    label: "Course Intakes",
    subtitle: "Manage intake periods, quarters, and months",
    icon: FaCalendarAlt,
  },
  {
    id: "categories",
    label: "Provider Categories",
    subtitle: "Organize providers by category and status",
    icon: FaLayerGroup,
  },
];

export const PROVIDER_SETTINGS_TAB_IDS = new Set(
  PROVIDER_SETTINGS_TABS.map((tab) => tab.id),
);

export const PROVIDER_SETTINGS_PATH_TAB_MAP = {
  "/providers/view-levels": "levels",
  "/providers/view-intakes": "intakes",
  "/providers/provider-categories": "categories",
};

export const PROVIDER_SETTINGS_TAB_PATH_MAP = {
  levels: "/providers/view-levels",
  intakes: "/providers/view-intakes",
  categories: "/providers/provider-categories",
};

export function resolveProviderSettingsTab(pathname, searchParams) {
  const fromPath = PROVIDER_SETTINGS_PATH_TAB_MAP[pathname];
  if (fromPath) return fromPath;

  const fromQuery = searchParams?.get?.("tab");
  if (fromQuery && PROVIDER_SETTINGS_TAB_IDS.has(fromQuery)) {
    return fromQuery;
  }

  return "levels";
}
